import { Navbar } from '@/components/Navbar';
import { Button } from '@/components/ui/button';
import { AlertTriangle, Home } from 'lucide-react';
import { Link } from 'wouter';

export default function NotFound() {
  return (
    <div className="flex min-h-[100dvh] flex-col bg-background">
      <Navbar />
      <div className="flex flex-1 items-center justify-center p-4">
        <div className="border-2 border-dashed border-destructive/50 bg-destructive/5 p-16 text-center animate-pulse">
          <AlertTriangle className="mx-auto mb-6 h-16 w-16 text-destructive" />
          <h1 className="mb-2 text-4xl font-black tracking-tighter font-display uppercase text-destructive">
            404: PAGE NOT FOUND
          </h1>
          <p className="mt-4 mb-8 text-sm font-mono text-muted-foreground uppercase tracking-widest">
            THIS PAGE DOES NOT EXIST
          </p>
          <Link href="/">
            <Button variant="outline" className="rounded-none font-mono uppercase tracking-widest text-primary border-primary hover:bg-primary/10">
              <Home className="mr-2 h-4 w-4" /> BACK TO HOME
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
